import { gpHome } from '../../app';
import { IUibModalInstance, ModalService } from '../../../app-common/services/bootstrap-ui-modal';
import gpCheckToReenableBillingDialogTemplate from './gp-check-to-reenable-billing-dialog.html';

export interface gpCheckToReenableBillingDialogOptions {
}

export interface gpCheckToReenableBillingDialogResult {
}

interface gpCheckToReenableBillingDialogScope {
    endDate: string;
    ok(): void;
    cancel(): void;
}

gpHome.controller('gpCheckToReenableBillingDialog', ['$scope', '$uibModalInstance', 'options',
    function (
        $scope: gpCheckToReenableBillingDialogScope,
        $uibModalInstance: IUibModalInstance<gpCheckToReenableBillingDialogResult>,
        options: gpCheckToReenableBillingDialogOptions
    ) {
        // put dialog optoins into the scope here.
        // $scope.endDate = options.endDate;

        $scope.ok = () => {
            let result: gpCheckToReenableBillingDialogResult = {
            };

            $uibModalInstance.close(result);
        };

        $scope.cancel = () => {
            $uibModalInstance.dismiss('cancel');
        };

    }]);

export class CheckToReenableBillingDialogService {
    static $inject = ['gpModal'];

    constructor(private readonly modalService: ModalService) {
    }

    showDialog(options: gpCheckToReenableBillingDialogOptions): ng.IPromise<gpCheckToReenableBillingDialogResult> {

        const modalInstance = this.modalService.open<gpCheckToReenableBillingDialogResult>({
            animation: true,
            template: gpCheckToReenableBillingDialogTemplate,
            controller: 'gpCheckToReenableBillingDialog',
            backdrop: true,
            backdropClass: 'gameplan-gp-check-to-reenable-billing-dialog',
            windowClass: 'gameplan-gp-check-to-reenable-billing-dialog',
            resolve: {
                options: () => options,
            },
        });

        return modalInstance.result;
    }
}

gpHome.service('gpCheckToReenableBillingDialogService', CheckToReenableBillingDialogService);
